import { render, staticRenderFns } from "./ConsumptionEdit.vue?vue&type=template&id=631bd530&scoped=true"
import script from "./ConsumptionEdit.vue?vue&type=script&lang=js"
export * from "./ConsumptionEdit.vue?vue&type=script&lang=js"
import style0 from "./ConsumptionEdit.vue?vue&type=style&index=0&id=631bd530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631bd530",
  null
  
)

export default component.exports